import { Validator } from 'utils';
import * as Yup from 'yup';

export class UpdateDriverValidator {
  public get schema() {
    return Yup.object().shape({
      name: Yup.string().required('Informe o nome do motorista'),
      document: Yup.mixed().test({
        name: 'testDocument',
        test: function (value: string) {
          try {
            if (!Validator.isValidCPF(value)) throw new Error('CPF inválido');
            return true;
          } catch (error: any) {
            return this.createError({
              message: error?.message,
            });
          }
        },
      }),
      cellPhone: Yup.string().required('Informe o celular do motorista'),
    });
  }
}
